import { render } from "./sidenav.vue?vue&type=template&id=1c417b0e"
import script from "./sidenav.vue?vue&type=script&lang=js"
export * from "./sidenav.vue?vue&type=script&lang=js"
script.render = render

export default script